import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ComercioIA, IaService } from 'src/app/services/ia/ia.service';
import { errorDeIA, nf, puedeConfigurarIA, usd, usdCorto } from 'src/app/services/ia/ia-formato';

/**
 * SOLAPA «COMERCIOS» — `console/ia/comercios`.
 *
 * TODOS los comercios, con el interruptor del asistente, su tope, el gasto de
 * hoy y las preguntas de la semana. El que no tiene documento en `ia_comercios`
 * viene `habilitado:false`: el asistente NACE APAGADO (CONTRATO §2, nivel 4).
 *
 * 📌 El interruptor guarda al tocarlo, sin confirmar: prender o apagar UN
 * comercio se deshace con otro toque. La confirmación con APAGAR es sólo para
 * el interruptor general.
 *
 * 📌 La fila entera lleva a la solapa «Asistente de IA» de la ficha del
 * comercio (`console/merchants/:code/asistente`), que es donde vive lo demás:
 * el tope propio, la clave propia y sus últimas preguntas.
 *
 * Filtrado en el cliente: son decenas de comercios, no miles (molde de
 * `comercios-list`). `?q=` del servidor queda en el servicio para cuando haga falta.
 */
@Component({
  selector: 'app-ia-comercios',
  templateUrl: './ia-comercios.component.html',
  styleUrls: ['./ia-comercios.component.css']
})
export class IaComerciosComponent implements OnInit {

  cargando = true;
  error: string | null = null;
  comercios: ComercioIA[] = [];

  busqueda = '';
  filtro: 'todos' | 'prendidos' | 'apagados' = 'todos';

  cambiando: string | null = null;
  errorFila: { [codigo: string]: string | null } = {};

  readonly usd = usd;
  readonly usdCorto = usdCorto;
  readonly nf = nf;

  constructor(private _ia: IaService, private router: Router, public _auth: AuthService) { }

  ngOnInit(): void { this.cargar(); }

  get puedeEditar(): boolean { return puedeConfigurarIA(this._auth); }

  cargar = async (): Promise<void> => {
    this.cargando = true;
    this.error = null;
    try {
      const r = await this._ia.getComercios();
      this.comercios = (Array.isArray(r) ? r : [])
        .slice()
        .sort((a, b) => Number(b.habilitado) - Number(a.habilitado) || (a.nombre || a.codigo).localeCompare(b.nombre || b.codigo));
    } catch (e: any) {
      this.comercios = [];
      this.error = errorDeIA(e);
    } finally {
      this.cargando = false;
    }
  };

  get visibles(): ComercioIA[] {
    const q = this.busqueda.trim().toLowerCase();
    return this.comercios.filter((c) =>
      (this.filtro === 'todos' || (this.filtro === 'prendidos' ? c.habilitado : !c.habilitado))
      && (!q || (c.codigo || '').toLowerCase().includes(q) || (c.nombre || '').toLowerCase().includes(q)));
  }

  get prendidos(): number { return this.comercios.filter((c) => c.habilitado).length; }
  get preguntas7d(): number { return this.comercios.reduce((s, c) => s + Number(c.preguntas7d || 0), 0); }
  get gastoHoy(): number { return this.comercios.reduce((s, c) => s + Number(c.gastoHoyUsd || 0), 0); }

  porCodigo = (_: number, c: ComercioIA): string => c.codigo;

  abrir = (c: ComercioIA): void => {
    this.router.navigate(['/console/merchants', c.codigo, 'asistente']);
  };

  alternar = async (c: ComercioIA, habilitado: boolean): Promise<void> => {
    this.cambiando = c.codigo;
    this.errorFila[c.codigo] = null;
    try {
      await this._ia.guardarComercio(c.codigo, { habilitado });
      c.habilitado = habilitado;
    } catch (e: any) {
      this.errorFila[c.codigo] = errorDeIA(e, true);
    } finally {
      this.cambiando = null;
    }
  };

  tieneClavePropia = (c: ComercioIA): boolean => !!c.credencialPropia;
}
